import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_HOST;

export type GlobalSearchResult = {
  id: string;
  type: string;
  title: string;
  subtitle: string;
  href: string;
};

export const searchService = {
  async globalSearch(query: string): Promise<GlobalSearchResult[]> {
    const response = await axios.get(`${API_BASE_URL}/v1/search`, {
      params: { q: query },
    });

    return response?.data?.data || [];
  },
};
